// inital JS load
(($) => {

    // when document ready,
    document.addEventListener('DOMContentLoaded', () => {

        /* term highlighting */
        function loadTerms(glossaryTerms) {
            const definitions = [...glossaryTerms].map(w=> ({
                term: w.name,
                definition: w.content
            }));

            window.glossary = {
                "items": definitions
            };

            const keys = {};
            const toTransform = [];

            document.querySelectorAll('.main > *:not(.hero):not(.upcoming) *:not(a):not(button)').forEach($el => {
                for (var i = 0; i < $el.childNodes.length; ++i) {
                    if ($el.childNodes[i].nodeType === Node.TEXT_NODE) {

                        for (var g = 0; g < glossaryTerms.length; g++) {
                            const w = glossaryTerms[g];
                            const regex1 = new RegExp('\\b' + w.name.toLowerCase() + '\\b', 'g');
                            const regex2 = new RegExp('\\b' + w.name + '\\b', 'g');
                            let newContent = $el.childNodes[i].textContent;
                            let found = false;

                            if (newContent.toLowerCase().match(regex1)) {

                                const key = crypto.randomUUID();

                                newContent = newContent.replace(regex1, '{' + key + '}');

                                keys[key] = `<mark class="idef" data-idef="${w.name}">${w.name.toLowerCase()}</mark>`;
                                found = true;
                            }

                            if (newContent.match(regex2)) {

                                const key = crypto.randomUUID();

                                newContent = newContent.replace(regex2, '{' + key + '}');

                                keys[key] = `<mark class="idef" data-idef="${w.name}">${w.name}</mark>`;
                                found = true;
                            }

                            if ( found ) {
                                toTransform.push($el);
                                $el.innerHTML = newContent;
                                glossaryTerms.splice(g, 1);
                            }
                        }

                    }
                }
            });

            toTransform.forEach($el => {
                let html = $el.innerHTML;
                for (const key in keys) {
                    html = html.replace("{"+key+"}", keys[key]);
                }
                $el.innerHTML = html;
            });

            document.querySelectorAll('[data-glossary-index]').forEach($et => $et.addEventListener('click', (eb) => {
                eb.preventDefault();
            }));

            $("body").instantDefinitions();
        }

        const $glossary = document.querySelector('.glossary');
        if (!$glossary) {

            setTimeout(() => {

                // fetch('/wp-json/ui/v1/glossary/')
                //     .then(data => data.json())
                //     .then(data => {
                //         loadTerms(data);
                //     });

            }, 1000);

            return;
        }

        const originalResultsCount = document.querySelectorAll('.glossary__result').length;

        const $title = document.querySelector('.glossary__results-title');
        const $typeFilter = document.querySelector('.glossary__results-filter[data-type="search"]');
        let typeSearch = "";

        const $letterFilter = document.querySelector('.glossary__results-filter[data-type="letter"]');
        let letterSearch = "";

        function searchRecords(term, letter) {
            typeSearch = term;
            letterSearch = letter.toUpperCase();

            $typeFilter.querySelector('span').textContent = typeSearch;
            $letterFilter.querySelector('span').textContent = letterSearch;

            document.querySelectorAll('.glossary__result').forEach($el => {
                let matches = true;

                if (letterSearch && $el.dataset.letterStart.toUpperCase() != letterSearch) {
                    matches = false;
                }

                console.log(1, {matches});

                if (matches && typeSearch && -1 == $el.dataset.search.toLowerCase().indexOf(typeSearch.toLowerCase())) {
                    matches = false;
                }

                $el.setAttribute('data-visible', matches);
            });

            const resultsCount = document.querySelectorAll('.glossary__result[data-visible="true"]').length;
            $title.textContent = (!typeSearch && !letterSearch) ? "All Results" : resultsCount + " Result" + (resultsCount != 1 ? "s" : "");

            $typeFilter.style.display = typeSearch == "" ? 'none' : 'flex';
            $letterFilter.style.display = letterSearch == "" ? 'none' : 'flex';

            document.querySelector('.glossary__results-filters').setAttribute('data-has-results', !!(typeSearch || letterSearch));
            document.querySelector('.glossary__form-input input').value = typeSearch;
            document.querySelectorAll('[data-letter]').forEach($l => $l.classList.remove('-isSelected'));

            if (letterSearch) {
                document.querySelector('[data-letter="' + letterSearch + '"]').classList.add('-isSelected');
            }
        }

        let typeTimer = null;
        document.querySelector('.glossary__form-input input').addEventListener('keyup', e => {
            if (e.target.value.length < 3) {
                return;
            }

            if (typeTimer) {
                clearTimeout(typeTimer);
            }

            typeTimer = setTimeout(() => {
                searchRecords(e.target.value, letterSearch);
            }, 300);
        });

        document.querySelector('.glossary__results-filters-clear').addEventListener('click', e => {
            e.preventDefault();
            searchRecords('', '');
        });

        document.querySelector('.glossary__results-filter[data-type="search"]').addEventListener('click', e => {
            e.preventDefault();
            searchRecords('', letterSearch);
        });

        document.querySelector('.glossary__results-filter[data-type="letter"]').addEventListener('click', e => {
            e.preventDefault();
            searchRecords(typeSearch, '');
        });

        document.querySelectorAll('[data-letter]').forEach($e => $e.addEventListener('click', e => {
            e.preventDefault();
            searchRecords(typeSearch, e.target.dataset.letter);
        }));


    }, false);

})(jQuery);